import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { customerSlugError } from '@/lib/categories/attribute-slugs';

interface Props {
  id: string;
  label: string;
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export function CustomerSlugInput({ id, label, value, disabled, onChange }: Props) {
  const error = customerSlugError(value);
  return <div className="space-y-1">
    <Label htmlFor={id}>{label} (optional)</Label>
    <Input id={id} value={value} disabled={disabled} onChange={event => onChange(event.target.value)}
      aria-invalid={!!error} aria-describedby={`${id}-hint`} />
    <p id={`${id}-hint`} className={error ? 'text-xs text-destructive' : 'text-xs text-muted-foreground'}>
      {error ?? `${Array.from(value.trim()).length}/100 characters. Returned in API responses.`}
    </p>
  </div>;
}
